/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-primary[_ngcontent-%COMP%]{color:#1b76bb!important}.approval[_ngcontent-%COMP%], .port[_ngcontent-%COMP%]{text-decoration:none;border-bottom:2px solid #136ee6}"];
export { styles as styles };
